import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

interface IPostDetail {
    category: string
    channel: string
    comments_count: number
    content?: string
    created_at: number
    guild_id: string
    id: string
    images?: string[]
    is_liked: boolean
    language: string
    likes_count: 0
    title?: string
    user: {
        id: string
        is_official: boolean
        name: string
        status: string
        thumbnail?: string
    }
    user_id: string
    visibility: number
}

export const getPostDetail = async (id: string): Promise<ApiRes<IPostDetail>> => {
    return await apiGet(API_URL, `admin/post/${id}`)
}
